var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQBXzEFgp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_972_5242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 1.75H11.5V0H10.5V1.75H4.5V0H3.5V1.75H0.75C0.551159 1.75023 0.360528 1.82932 0.219926 1.96993C0.0793236 2.11053 0.000231576 2.30116 0 2.5V13C0.000231576 13.1988 0.0793236 13.3895 0.219926 13.5301C0.360528 13.6707 0.551159 13.7498 0.75 13.75H14.25C14.4488 13.7498 14.6395 13.6707 14.7801 13.5301C14.9207 13.3895 14.9998 13.1988 15 13V2.5C14.9998 2.30116 14.9207 2.11053 14.7801 1.96993C14.6395 1.82932 14.4488 1.75023 14.25 1.75ZM14 12.75H1V2.75H3.5V4H4.5V2.75H10.5V4H11.5V2.75H14V12.75Z",
    fill: "#32239B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 8.5L6.5 10L10.5 6",
    stroke: "#32239B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_972_5242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQBXzEFgp);
export default __webpack_public_path__ + "static/media/qBXzEFgp.a684908fdc846f38ad53753b962bd86d.svg";
export { ForwardRef as ReactComponent };